import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getCreditCustomers: EvokeAction<AppState, AppActions> = async store => {
  try {
    const creditCustomers = await api.get("customers-credit");
    await store.update(state => {
      state.creditCustomers = creditCustomers;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const creditCustomerActions = {
    getCreditCustomers
};
